import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Button } from '@platform/design-system';
import { RouterLink } from "../router/router-link.js";
import { longDate } from "./copy.js";
import { useWorkspace } from "./queries.js";
/**
 * A reminder above every page while a deletion is scheduled: the date, and (for an admin) where
 * to cancel. Nothing renders otherwise, while loading, or if the workspace cannot be read.
 */
export function DeletionBanner({ subject, manageHref, }) {
    const workspace = useWorkspace();
    const scheduled = workspace.data?.deletion;
    if (!scheduled)
        return null;
    return (_jsxs(Alert, { severity: "warning", role: "status", sx: { mb: 2 }, action: manageHref ? (_jsx(Button, { size: "small", color: "inherit", component: RouterLink, href: manageHref, children: "Review or cancel" })) : undefined, children: [subject === 'account' ? 'Your account' : 'This workspace', " is set to be deleted on", ' ', _jsx("strong", { children: longDate(scheduled.purgeAt) }), "."] }));
}
//# sourceMappingURL=deletion-banner.js.map